var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalgar3Ny01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.91 70.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "-10.46 64.19 107.34 64.19 107.34 3.71 -10.46 3.71 -10.46 64.19"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 10.51,
    y1: 35.1,
    x2: 86.08,
    y2: 35.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.05,
    y1: 13.38,
    x2: 14.05,
    y2: 56.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.24,
    y1: 13.44,
    x2: 23.02,
    y2: 56.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.32,
    y1: 13.44,
    x2: 30.13,
    y2: 56.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.21,
    y1: 13.44,
    x2: 33.4,
    y2: 56.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 49.48,
    y1: 13.38,
    x2: 49.48,
    y2: 56.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 54.67,
    y1: 13.44,
    x2: 58.45,
    y2: 56.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 65.56,
    y1: 13.44,
    x2: 61.75,
    y2: 56.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 70.75,
    y1: 13.38,
    x2: 70.75,
    y2: 56.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.94,
    y1: 13.44,
    x2: 79.72,
    y2: 56.76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalgar3Ny01);
export default __webpack_public_path__ + "static/media/galgar 3 ny-01.6d2f1e31062bdef69a688d983a7831d8.svg";
export { ForwardRef as ReactComponent };